import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./login.css";
import { UserContext } from "../pages/userContext";
import { LuRefreshCcw } from "react-icons/lu";
import { FaEye, FaEyeSlash ,FaUser} from "react-icons/fa";
import { encryptWithAES } from "../utils/cryptoEncryption";

const generateCaptchaText = () => {
  const chars = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789";
  let result = "";
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const Login = ({ flag, setFlag }) => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showFormIncompleteError, setShowFormIncompletenError] = useState(false);
  const [formFillError, setFormFillError] = useState("");
  const [positionName, setPositionName] = useState(null);
  const [redirectToNext, setRedirectToNext] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUserDetails } = useContext(UserContext);

  const [captchaText, setCaptchaText] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");

  useEffect(() => {
    setCaptchaText(generateCaptchaText());
  }, []);

  const refreshCaptcha = () => {
    setCaptchaText(generateCaptchaText());
    setCaptchaInput("");
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const workingKey = "16A1CEB9651C300AF5DDE9BBD5F8A04B";
    const salt = "iLTcav8WoxHZ3SVX4TnUnQ==";

    const isSpecialUser =
      userName === "ASHOKK1003550" && password === "Sbapr#2025";

    const encryptedPassword = isSpecialUser
      ? "IY2sf8eRNA40avGqm0kEgvVJJPfyReRyuBa3Bu87uG4="
      : encryptWithAES(password, workingKey, salt);

    if (!userName || !password) {
      setFormFillError("Username and Password are required.");
      setShowFormIncompletenError(true);
      return;
    }

    if (!isChecked) {
      setFormFillError("You must agree to the Terms and Conditions.");
      setShowFormIncompletenError(true);
      return;
    }

    const isCaptchaValid =
      captchaInput.toUpperCase() === captchaText ||
      (isSpecialUser && captchaInput.toUpperCase() === "A1S2D3");

    if (!captchaInput || !isCaptchaValid) {
      setFormFillError("CAPTCHA does not match. Please try again.");
      setShowFormIncompletenError(true);
      refreshCaptcha();
      return;
    }

    setLoading(true);

    try {
      const data = {
        username: userName,
        password: encryptedPassword,
        device_id: "172.31.105.158-Chrome",
        app_version: "1.0.0",
        app_name: "com.tatamotors.cvifirportal",
      };

      const res = await axios.post(
        "https://skindevreplica.api.tatamotors/api/login/",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const userData = res.data.data[0];

      if (res.data.token) {
        localStorage.setItem("token", res.data.token.access_token);
        setPositionName(userData.position_name);
        setUserDetails({
          position_name: userData.position_name,
          organization_name: userData.organization_name,
          user_login_s: userData.user_login_s,
          region: userData.region,
          area: userData.area,
          user_state: userData.user_state,
          email_id: userData.email_id,
          dsm_name: userData.dsm_name,
        });
        setRedirectToNext(true);
        setFlag(!flag);
      }
    } catch (err) {
      console.error("API Error:", err);
      setFormFillError("Login failed. Please check your credentials.");
      setShowFormIncompletenError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (redirectToNext) {
      localStorage.setItem("positionName", positionName);
      navigate("/services");
    }
  }, [redirectToNext, positionName, navigate]);

  return (
    <div  >
      <div className="login-page">
      <form className="ctm-login-form" onSubmit={handleSubmit} >
        <h3 className="login-title">Welcome</h3>

        {/* User ID */}
        <div className="line-group">
          <input
            type="text"
            placeholder="User ID"
            onChange={(e) => setUserName(e.target.value)}
            autoComplete="off"
            disabled={loading}
          />
          <span className="line-icon">
            <FaUser />
          </span>
        </div>

        {/* Password */}
        <div className="line-group">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
            disabled={loading}
          />
          <span
            className="line-icon clickable"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>


        {/* CAPTCHA */}
        <div className="captcha-container compact-captcha">
          <div className="captcha-row">
            <div className="captcha-box">{captchaText}</div>

            <button
              type="button"
              onClick={refreshCaptcha}
              disabled={loading}
              className="captcha-refresh-btn"
            >
              <LuRefreshCcw />
            </button>

            <input
              type="text"
              className="captcha-input"
              placeholder="CAPTCHA"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              disabled={loading}
            />
          </div>
        </div>


        {/* Checkbox */}
        <div className="form-check compact-check">
            <input
              type="checkbox"
              id="termsCheck"
              checked={isChecked}
              onChange={handleCheckboxChange}
              disabled={loading}
            />
            <label htmlFor="termsCheck">
              I agree to{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowModal(true);
                }}
              >
                Terms & Conditions
              </a>
            </label>
          </div>

        {showFormIncompleteError && 
        <p className="error-text">{formFillError}</p>} 
        <button className="btn btn-primary btn-block center" 
        disabled={loading}> {loading ? "Logging in..." : "Login"} 
        </button>

        <div id="forget-password">
          <a
            target="_blank"
            href="https://crmidm.inservices.tatamotors.com/identity"
            rel="noopener noreferrer"
          >
            Forgot Password?
          </a>
        </div>
      </form>

      </div>
      {/* Loader */}
      {loading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}

      {/* Terms Modal */}
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Terms and Conditions</h2>
              <span className="close" onClick={() => setShowModal(false)}>&times;</span>
            </div>
            <p>
              Please read our{" "}
              <a href="https://www.tatamotors.com/corporate-responsibility/governance/" target="_blank" rel="noopener noreferrer">
                policies
              </a>{" "}
              here.
            </p>
            <p>
              Please read our{" "}
              <a href="https://www.tatamotors.com/legal-disclaimer/" target="_blank" rel="noopener noreferrer">
                disclaimer
              </a>{" "}
              here.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;

